export const maxMessageLength = 500
